module.exports = __webpack_public_path__ + "img/invite_avater.5b59bb01.png";